import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useProfilePhoto } from "../components/useProfilePhoto";

export default function Header({ onToggleSidebar }) {
  const { accounts, instance } = useMsal();
  const account = accounts[0];
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const photo = useProfilePhoto();
  const handleLogout = () => instance.logout();

  return (
    <header className="sticky top-0 left-0 right-0 z-30 bg-white/80 backdrop-blur-xl border-b border-gray-200/50 shadow-sm">
      <div className="px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14 sm:h-16">
        <div className="flex items-center">
          <button
            id="sidebarToggle"
            className="text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:ring-offset-2 rounded-lg p-2 transition-all duration-200"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
          >
            <FontAwesomeIcon icon={faBars} className="w-5 h-5" />
          </button>

          {/* Mobile logo/title */}
          <div className="ml-4 sm:hidden">
            <span className="text-lg font-bold text-gray-800">cora Group</span>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <div className="relative">
            <button
              id="profileDropdown"
              className="flex items-center space-x-2 sm:space-x-3 p-2 rounded-xl focus:outline-none hover:bg-gray-50 transition-all duration-200 group"
              onClick={() => setIsProfileOpen(!isProfileOpen)}
              aria-expanded={isProfileOpen}
              aria-haspopup="true"
            >
              <div className="hidden sm:flex flex-col text-right">
                <span className="text-sm font-semibold text-gray-700 group-hover:text-gray-900 transition-colors">
                  {account?.name || "Guest"}
                </span>
              </div>
              <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#144677] to-[#1a5691] ring-2 ring-offset-2 ring-transparent group-hover:ring-[#144677]/20 transition-all duration-200 shadow-md">
                <img
                  src={
                    photo ||
                    "https://api.dicebear.com/7.x/avataaars/svg?seed=cora"
                  }
                  alt="Profile"
                  className="h-full w-full rounded-full object-cover"
                />
              </div>
            </button>

            {/* Dropdown Menu */}
            <div
              id="dropdownMenu"
              onMouseLeave={() => setIsProfileOpen(false)}
              className={`${
                isProfileOpen ? "block" : "hidden"
              } absolute right-0 mt-2 w-56 sm:w-64 rounded-xl shadow-xl bg-white/95 backdrop-blur-xl ring-1 ring-black/5 divide-y divide-gray-100 focus:outline-none z-50 transform transition-all duration-200 origin-top-right ${
                isProfileOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
              }`}
            >
              <div className="py-3 px-4 bg-gradient-to-br from-[#144677]/5 to-[#1a5691]/5 rounded-t-xl">
                <p className="text-sm font-semibold text-gray-900 truncate">
                  {account?.name || "Guest"}
                </p>
                <p className="text-sm text-gray-500 truncate mt-0.5">
                  {account?.username || ""}
                </p>
              </div>

              <div className="py-1">
                <button
                  className="flex items-center w-full px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gradient-to-r hover:from-red-50 hover:to-red-50/50 hover:text-red-600 transition-all duration-200 focus:outline-none focus:bg-red-50 group"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <svg
                    className="mr-3 h-4 w-4 text-gray-400 group-hover:text-red-500 transition-colors duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                  Sign out
                </button>
              </div>
            </div>

            {/* Backdrop for mobile dropdown */}
            {isProfileOpen && (
              <div
                className="fixed inset-0 z-40 sm:hidden bg-black/20 backdrop-blur-sm"
                onClick={() => setIsProfileOpen(false)}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
